export const RequiredArtistsFields = [
  'type',
  'last_name_or_company_name',
  'website_visible',
];
// export const SelectableArtistsFields = [
//   'type'
// ];
export const maxArtsistListValue = 5001;
